import React from "react";
import { TModuleTheory } from "../../../entities/Moodle/model/MoodleTypes";

interface Props {
  module: TModuleTheory;
}

const TheoryModuleWidget = ({ module }: Props) => {
  return (
    <div>
      {module?.content && (
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 15,
          }}
          key={module?.coursemodule}
        >
          <h4 style={{ marginTop: 5, marginBottom: 5, textAlign: "center" }}>
            {module?.name}
          </h4>
          <div dangerouslySetInnerHTML={{ __html: module?.intro }} />
          <div dangerouslySetInnerHTML={{ __html: module?.content }} />
        </div>
      )}
    </div>
  );
};

export default TheoryModuleWidget;
